import styled from 'styled-components'

export const AppMain = styled.main`
  margin-top: 45px;
  height: 100%;
  width: auto;
  overflow-y: hidden;
  /* border: 3px solid fuchsia; */
`;